import {
  useState,
  useCallback,
  useEffect,
  useRef
} from 'react';
import {
  Container,
  Content,
  Title,
  ListUsers,
  AccessLevelInfo,
  AccessLevelPermissions
} from './styled';
import {
  Search,
  Modal,
  UserForm,
} from '../../../../components';
import { CardUser } from './CardUser';
import {
  FaUsers,
  FaUserPlus,
  FaInfoCircle
} from "react-icons/fa";
import {
  getUsers
} from '../../../../service/serviceChat/usersService';
import {
  getAccessLevel
} from '../../../../service/serviceChat/accessLevelService';
import {
  getAllGroups,
} from '../../../../service/serviceChat/groupService';
import { FaFilter } from "react-icons/fa6";

export function List() {

  const [users, setUsers] = useState([]);
  const [filter, setFilter] = useState('');
  const [filterStatusUser, setFilterStatusUser] = useState(
    { id: 1, value: false, name: "Todos" }
  );
  const [settingsModal, setSettingsModal] = useState(null);
  const [accessLevel, setAccessLevel] = useState(null);
  const [groups, setGroups] = useState(null);
  // const [viewPermissions, setViewPermissions] = useState(false);
  const [selectedPermissions, setSelectedPermissions] = useState([]);
  const [viewFilterPermissions, setViewFilterPermissions] = useState(false);

  const searchUsersAndAccessLevelAndGroups = useCallback(async () => {
    const allResolved = await Promise.all([
      getUsers(),
      getAccessLevel(),
      getAllGroups()
    ]);
    setUsers(allResolved[0]);
    setAccessLevel(allResolved[1]);
    setGroups(allResolved[2]);
  }, []);

  useEffect(() => {
    searchUsersAndAccessLevelAndGroups();
  }, []);

  const informationRef = useRef(null);
  const filterRef = useRef(null);

  const handleClickOutside = useCallback((event) => {
    // if (informationRef.current && !informationRef.current.contains(event.target)) {
    //   setViewPermissions(false); // Fecha InformationPermissions quando clicar fora
    // }
    if (filterRef.current && !filterRef.current.contains(event.target)) {
      setViewFilterPermissions(false); // Fecha InformationPermissions quando clicar fora
    }
  }, []);

  useEffect(() => {
    if ( viewFilterPermissions) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [viewFilterPermissions, handleClickOutside]);

  function onFilter(user) {
    const nameMatch =
      user?.nomecompleto?.toLowerCase()?.includes(filter?.toLowerCase()) ||
      user?.nomeusuario?.toLowerCase()?.includes(filter?.toLowerCase());

    const statusMatch =
      filterStatusUser?.value ? user.ativo === filterStatusUser?.value : true;

    const permissionMatch =
      selectedPermissions.length > 0
        ? user.access_level?.some((a) =>
          selectedPermissions.includes(a.access_level_id)
        )
        : true;

    return nameMatch && statusMatch && permissionMatch;
  }

  const handleNewUser = () => {
    setSettingsModal({
      action: 'createUser',
      data: null,
    });
  };

  const handleConfigUser = (user) => {
    setSettingsModal({
      action: 'configUser',
      data: user,
    });
  };

  // const InformationPermissions = () => {
  //   return (
  //     <AccessLevelInfo
  //       ref={informationRef}
  //       className={`${viewPermissions && 'accessLevelInfo'}`}
  //     >
  //       {accessLevel?.length > 0 &&
  //         accessLevel?.map((access) => {
  //           return (
  //             <li key={access?.id}>
  //               <span>
  //                 {access?.abreviatura}
  //               </span>
  //               <div>
  //                 {access?.descricao}
  //               </div>
  //             </li>
  //           );
  //         })
  //       }
  //     </AccessLevelInfo>
  //   );
  // };

  const FilterPermissions = () => {
    const handleSelectPermission = (id) => {
      setSelectedPermissions((prev) =>
        prev.includes(id)
          ? prev.filter((item) => item !== id)
          : [...prev, id]
      );
    };

    const handleClearFilters = (e) => {
      e.stopPropagation();
      setSelectedPermissions([]);
    };

    return (
      <AccessLevelPermissions
        ref={filterRef}
        className={`${viewFilterPermissions ? 'accessLevelInfo' : ''}`}
      >
        {selectedPermissions.length > 0 && (
          <button className="clear-btn" onClick={handleClearFilters}>
            ✕
          </button>
        )}

        {accessLevel?.length > 0 &&
          accessLevel?.map((access) => (
            <li key={access?.id} onClick={(e) => e.stopPropagation()}>
              <span>{access?.abreviatura}</span>
              <div>{access?.descricao}</div>
              <input
                type="checkbox"
                checked={selectedPermissions.includes(access?.id)}
                onChange={() => handleSelectPermission(access?.id)}
              />
            </li>
          ))}
      </AccessLevelPermissions>
    );
  };

  return (
    <Container>
      <Title>
        <span>
          <FaUsers fontSize={'3rem'} />
        </span>
        <div>
          {`Listagem de Usuários `}
        </ div>
      </Title>
      <Content>
        <div>
          <Search
            className={`uFN`}
            value={filter}
            onChange={(e) => setFilter(e.target.value)}
            placeholder={`Buscar Usuário`}
          />
          <button onClick={() => handleNewUser()}>
            <FaUserPlus fontSize={'1.5rem'} />
            {`Novo Usuário`}
          </button>
        </div>
        <ListUsers>
          <div>
            <span>
              {`Usuário`}
            </span>
            <span>
              {`Permissões `}
              {(accessLevel?.length > 0) && (
                <>
                  {/* <span>
                    <FaInfoCircle
                      onClick={() => setViewPermissions(true)}
                      style={{ pointerEvents: !viewPermissions ? 'all' : 'none' }}
                    />
                    <InformationPermissions />
                  </span> */}

                  <span>
                    <FaFilter
                      onClick={() => setViewFilterPermissions(true)}
                      style={{ pointerEvents: !viewFilterPermissions ? 'all' : 'none' }}
                    />
                    <FilterPermissions />
                  </span>
                </>
              )}
            </span>
          </div>
          <ul>
            {users?.length > 0 &&
              users?.filter(onFilter).map((user) => {
                return (
                  <CardUser
                    key={user?.id}
                    user={user}
                    onClick={() => { handleConfigUser(user); }}
                  />
                );
              })
            }
          </ul>
        </ListUsers>
      </Content>
      <Modal
        title={`${settingsModal?.action === 'createUser' ? 'Novo' : 'Configurar'} Usuário`}
        isOpen={settingsModal}
        close={() => setSettingsModal(null)}
        classNameContent="default-background"
      >
        {(settingsModal) && (
          <UserForm
            user={settingsModal?.data}
            usersList={users}
            accessLevel={accessLevel}
            groups={groups}
            callback={() => {
              searchUsersAndAccessLevelAndGroups();
              setSettingsModal(null);
            }}
          />
        )}
      </Modal>
    </Container>
  );
}